// extracted by mini-css-extract-plugin
export default {"btn":"SectionTagCopy_btn__4sEbJ","text":"SectionTagCopy_text__jT40m","badge":"SectionTagCopy_badge__iblX1"};